const countdownInnerHTML = `
  <div class="countdown__container">
    <div class="countdown__timer">
      <div class="countdown__wrapper">
        <div class="countdown__days countdown__number">00</div>
        <div class="countdown__label plural">${themeVariables.strings.countdownDays}</div>
        <div class="countdown__label singular" hidden>${themeVariables.strings.countdownDays}</div>
      </div>
      <div class="">:</div>
      <div class="countdown__wrapper">
        <div class="countdown__hours countdown__number">00</div>
        <div class="countdown__label plural">${themeVariables.strings.countdownHours}</div>
        <div class="countdown__label singular" hidden>${themeVariables.strings.countdownHour}</div>
        </div>
      <div class="">:</div>
      <div class="countdown__wrapper">
        <div class="countdown__minutes countdown__number">00</div>
        <div class="countdown__label plural">${themeVariables.strings.countdownMinutes}</div>
        <div class="countdown__label singular" hidden>${themeVariables.strings.countdownMinute}</div>
      </div>
      <div class="">:</div>
      <div class="countdown__wrapper">
        <div class="countdown__seconds countdown__number">00</div>
        <div class="countdown__label">${themeVariables.strings.countdownSeconds}</div>
      </div>
    </div>
    <div class="countdown__message">
      <div class="countdown__text"></div>
    </div>
  </div>
`;

class Countdown extends HTMLElement {
  constructor() {
    super();

    this.innerHTML = countdownInnerHTML;

    this.daysEl = this.querySelector('.countdown__days');
    this.hoursEl = this.querySelector('.countdown__hours');
    this.minutesEl = this.querySelector('.countdown__minutes');
    this.secondsEl = this.querySelector('.countdown__seconds');
    this.textEl = this.querySelector('.countdown__text');

    this.endDate = this.getAttribute('end-date');
    this.message = this.getAttribute('message');
    this.intervalId = null;
  }

  connectedCallback() {
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.intervalId = setInterval(() => {
      const timeLeft = new Date(this.endDate).getTime() - Date.now();

      if (timeLeft < 0) {
        this.stop();
        return;
      }

      const daysLeft = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hoursLeft = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const secondsLeft = Math.floor((timeLeft % (1000 * 60)) / 1000);

      this.daysEl.textContent = this.padNumber(daysLeft);
      this.hoursEl.textContent = this.padNumber(hoursLeft);
      this.minutesEl.textContent = this.padNumber(minutesLeft);
      this.secondsEl.textContent = this.padNumber(secondsLeft);
      this.textEl.textContent = this.message;

      if (daysLeft <= 1) this.showSingular(this.daysEl);
      if (hoursLeft <= 1) this.showSingular(this.hoursEl);
      if (minutesLeft <= 1) this.showSingular(this.minutesEl);

      this.setAttribute('visible', true);
    }, 1000);
  }

  stop() {
    clearInterval(this.intervalId);
  }

  padNumber(number) {
    return String(number).padStart(2, '0');
  }

  showSingular(baseEl) {
    const parent = baseEl.parentElement;
    parent.querySelector('.plural').setAttribute('hidden', true);
    parent.querySelector('.singular').removeAttribute('hidden');
  }
}

customElements.define('countdown-element', Countdown);
